export const initialNotesData = {
    "authors": [],
    "conceptCode": [],
    "concepts": [],
    "favourites": [],
    "pages": [],
    "subjects": [],
    "tags": [],
    "title": "",
    "subType": "",
    "createdFor": {},
  };